import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 1.5C6.75736 1.5 5.75 2.50736 5.75 3.75V20.25C5.75 21.4926 6.75736 22.5 8 22.5H17C18.2426 22.5 19.25 21.4926 19.25 20.25V3.75C19.25 2.50736 18.2426 1.5 17 1.5H8ZM17.75 3H7.25V21H17.75V3Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 10.25,
		y: 3.75,
		width: 4.5,
		height: 1.5,
		rx: .75,
		fill: "currentColor"
	})]
});
export default SvgPhone;
